// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__X0FIM","skeleton-animation":"styles_skeleton-animation__VNU_v","text--center":"styles_text--center__Gm_OK","text--right":"styles_text--right__GsQDy"};